import { useContainer } from '../../useContainer';
import { ClientApi } from '../../../api';
import { CreateClientDto } from '../../../commonTypes/client.types';
import { dispatch } from '../../../store';
import { addClient, setShowCreateClientForm } from '../../../store/slices/clients.slice';
import { ICallback } from '../../../commonTypes/hook.types';
import { useLocation, useNavigate } from 'react-router';

const useHttpPostClient = () => {
    const clientApi: ClientApi = useContainer(ClientApi);
    const navigate = useNavigate();
    const location = useLocation();

    const execSubmit = (body: CreateClientDto, callback: ICallback) => {
        const { exec, abort } = clientApi.create({
            body,
            onSuccess: resp => {
                dispatch(setShowCreateClientForm(false));
                dispatch(addClient(resp.body));
                if (location.pathname.startsWith('/clients')) navigate(`/clients/${resp.body.id}`);
                if (callback.onSuccess) callback.onSuccess();
            },
            onError: error => error,
        });
        exec();
        return abort;
    };

    return { execSubmit };
};

export default useHttpPostClient;
